(function () {

    var hostname = window.location.hostname;
    
    if (hostname.indexOf('.') < 0) {
        document.domain = hostname;
        return;
    }
    
    var tlds = [
           '.co.za', '.co.ke', '.com.au', '.com.cn', '.com.hk', '.co.id', '.co.jp', '.co.kr', '.com.my', '.co.nz',
           '.com.tw', '.co.th', '.com.vn', '.co.uk', '.com.tr', '.com.co', '.com.ec', '.com.py', '.com.pe', '.com.uy',
           '.com.ve'
    ];

    var tld;

    for (var i = 0; i < tlds.length; i++) {
        if (hostname.indexOf(tlds[i]) !== -1) {
            tld = tlds[i];
            hostname = hostname.replace(new RegExp(tld, 'i'), '');
        }
    }
    
    if (tld === undefined) {
        tld = hostname.replace(/^.*(\..*$)/i, '$1');
        hostname = hostname.replace(/(^.*)\..*$/i, '$1');
    }

    document.domain = hostname.replace(/(.*\.)*(.*$)/i, '$2') + tld;
    
})();

define("mmc.libs.documentDomain", function(){});

